export const getMatrixX2X4 = (state) => state?.matrix?.matrixX2X4 || {};
